import { Component, Input, OnInit } from '@angular/core';
import { Asset } from "../../../../model/asset";

@Component({
  selector: 'app-asset-technical-details',
  templateUrl: './asset-technical-details.component.html',
  styleUrls: ['./asset-technical-details.component.scss']
})
export class AssetTechnicalDetailsComponent implements OnInit {

  @Input()
  asset: Asset;

  jsonData: object;
  loadingTechnicalDetails: boolean;

  constructor() { }

  ngOnInit(): void {
    this.loadingTechnicalDetails = true;
    if(this.asset.technicalDetails) {
      this.jsonData = JSON.parse(this.asset.technicalDetails);
    }
    this.loadingTechnicalDetails = false;
  }

}
